import './global.js'
import Parse from 'parse';
import React from 'react';
import { Route, Link} from "react-router-dom";
import Leftsidebar from "./Leftsidebar.jsx";
//import Popup from "./Popup.jsx";
import $ from "jquery";
import CommonPopup from './CommonPopup.jsx';
class SearchPage extends React.Component {
    constructor(props) {
        super(props);
          this.state = {
            searchResultsPhoto:[],
            SearchTitles:'',
            isPopupOpen: false,
            post_common_id:''
        };        
         const queryString = window.location.href;
         var queryStrings = queryString?queryString.split("/")[3]:''; 
         var  part = queryStrings?queryStrings.split('='):'';
         var searchtext=part?part[1]:'';
         this.searchTitle = searchtext;
         this.getSearchResults();    
         localStorage.setItem('storestreamtabValue', this.searchTitle);
         localStorage.setItem('storestreampagepath', 'searchresult');            
         
    }

getSearchResults() {
      var self = this;
      //loop
      var query = new Parse.Query('User');
      query.equalTo('isSuggested', 1);
      query.descending('_created_at');
      let SearchTitle  = this.searchTitle;
     
      var self = this;
      query.find().then(function(result){
            if(result){
              let userSuggdataresult1 = [];
              if(result.length>0)
              {               
                   for (var i = 0; i < result.length; i++)
                   {
                     var user = result[i];
                     userSuggdataresult1[i]='_User$'+user.id;
                   } 
                    //loop
                    var queryphoto = new Parse.Query('Photo');
                    queryphoto.include("user");
                    queryphoto.limit(99999999999);
                    let jointuser=userSuggdataresult1;//["_User$5CJeW8oA1k","_User$lT8FObMmNn"];
                    //queryphoto.containedIn('user', jointuser);//commente
                    queryphoto.descending("createdAt");
                      if (SearchTitle) {
                        queryphoto.contains('caption', SearchTitle);
                      }
                    queryphoto.find().then(function(photo){
                        self.setState({ searchResultsPhoto: photo});
                        self.setState({ SearchTitles: SearchTitle});
                    });

                    //loop
              }
            } else {
                //console.log("No user found");
            }
        }, function(error){
                console.error("Error loading post Error: " + error);
        });
}
backHome= (event) => {
    window.location.href = "/";
}
render() {
        var searchResultsPhoto= this.state.searchResultsPhoto;
        var isPopupOpen= this.state.isPopupOpen;
        var postcommonid= this.state.post_common_id;
        const togglePopup = (postid) => {
            this.setState(prevState => ({
              isPopupOpen: !prevState.isPopupOpen,
          }));
          this.setState({ post_common_id: postid });
          $("body").addClass("modal-open-search");
        };  
        const streamid= (postid) =>{
           localStorage.setItem('storestreamid', postid);
           
        }    
         
        var self = this;
        return (
            <section className='post_list'>
                <div className='container'>
                    <div className='inner'>
                        <nav className='sidebar'>
                            <Leftsidebar/>
                        </nav>
                        <main className='listing search-listing'>
                            <div className='search-grid'>
                                <div className='tlt-part'>
                                {/*href='javascript: window.history.back()'*/}
                                    <a  href="javascript:void(0);"  onClick={this.backHome}><img src="/images/back-arrow.svg" alt="Close"/></a>
                                    <h1>{this.searchTitle?this.searchTitle:''}</h1>
                                </div>
                                <div className='grid-part'>
                                    <div class="gridPostRow">

                               {searchResultsPhoto && searchResultsPhoto.map(function (photo, i) {

                               let photoimage='';
                               if(photo.get("image") && photo.get("image").url()!==undefined)
                               {
                                   photoimage=photo.get("image").url();
                               }
                               else{
                                   photoimage="/images/default_userpic0.png";
                               } 

                                  {
                            return (
                                 <div class="gridPost"  key={i+100}>
                                 {/*={photo.id?"/post/"+photo.id:''}*/}
                                { /* onClick={() => this.openPopupCommon(photo.id)}    title={photo.get("caption")?photo.get("caption"):''} */}
                                 {/*href='javascript:void(0);'   onClick={(e) => {togglePopup(photo.id);}}*/}
                                           <a  href = "/stream" onClick={(e) => {streamid(photo.id);}}  > 
                                                <figure class="thumbnail">
                                                    <img  src={photoimage} />
                                                </figure>
                                            </a>
                                               
                                               {/*   <button onClick={(e) => {togglePopup(photo.id);}}>Open Popup</button>*/}

        
                                        </div>
                            );
                          }


                              })}

                                    {/*   <div class="gridPost">
                                            <a href="/post/pasdunb4ED">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/a27945920eebce7bb8ea450e0cb5fa04_thumbnail.jpg"/>
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/2EsYcZIBii">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/2EsYcZIBii">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/6b4758a0861a27967ded810dca3000eb_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        <div class="gridPost">
                                            <a href="/post/WmL3QeLgGE">
                                                <figure class="thumbnail">
                                                    <img src="https://elasticbeanstalk-us-east-1-592910437950.s3.amazonaws.com/776a874f37f7ab38752cc0d8ed5b6399_thumbnail.jpg" />
                                                </figure>
                                            </a>
                                        </div>
                                        */}

            


 <CommonPopup
          isOpen={isPopupOpen}
          onClose={(e) => {togglePopup(this.state.post_common_id);} } postcommonid={this.state.post_common_id}
        />

        

      

                                    </div>
                                </div>
                            </div>
                        </main>                    
                    </div>
                </div>
            </section>
        );
    }
}

/*class Myprofiles extends React.Component {
    render() {
    return (
        <div className="App">
        <div className="mainProfileWrapper">
          <div className="mainProfileColumn">adaffa

         

            <center>


            </center>
          </div>
        </div>
       
         
        </div>

    );
  }
}*/

export default SearchPage;



// WEBPACK FOOTER //
// ./src/SearchPage.jsx